<div class="app-loader">
    <mat-progress-spinner style="margin:0 auto;" value="50" mode="indeterminate" [diameter]="60">
    </mat-progress-spinner>
</div>